import { Capacitor } from '@capacitor/core';

/** True when running inside a Capacitor native shell (iOS or Android). False in browser and Electron. */
export function useIsNative(): boolean {
  return Capacitor.isNativePlatform();
}

/** Resolved platform identifier across all four shells. */
export function usePlatform(): 'web' | 'mobile-web' | 'desktop' | 'ios' | 'android' {
  if (typeof window !== 'undefined' && Boolean((window as Window & { electron?: unknown }).electron)) {
    return 'desktop';
  }
  const p = Capacitor.getPlatform();
  if (p === 'ios') return 'ios';
  if (p === 'android') return 'android';
  if (typeof navigator !== 'undefined' && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
    return 'mobile-web';
  }
  return 'web';
}
